// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "PDFViewer" + "." + "4029af85315fa3b78ff0" + ".css";
};